import ItalyImg from "./../../assets/images/countries/ItalyImg.png";
import DenmarkImg from "./../../assets/images/countries/DenmarkImg.png";
import IcelandImg from "./../../assets/images/countries/IcelandImg.png";
import IrelandImg from "./../../assets/images/countries/IrelandImg.png";
import NorwayImg from "./../../assets/images/countries/NorwayImg.png";
import SwitzerlandImg from "./../../assets/images/countries/SwitzerlandImg.png";
import FinlandImg from "./../../assets/images/countries/FinlandImg.png";
import LuxembourgImg from "./../../assets/images/countries/LuxembourgImg.png";
import NetherlandsImg from "./../../assets/images/countries/NetherlandsImg.png";
import SwedenImg from "./../../assets/images/countries/SwedenImg.png";
import UnitedKingdomImg from "./../../assets/images/countries/UnitedKingdomImg.png";
import GermanyImg from "./../../assets/images/countries/GermanyImg.png";
import FranceImg from "./../../assets/images/countries/FranceImg.png";

import IndiaImg from "./../../assets/images/countries/IndiaImg.png";
import JapanImg from "./../../assets/images/countries/JapanImg.png";
import ChinaImg from "./../../assets/images/countries/ChinaImg.png";
import SingaporeImg from "./../../assets/images/countries/SingaporeImg.png";
import ThailandImg from "./../../assets/images/countries/ThailandImg.png";



const shots = [
    {
      continent: "Asia",
      countries: [
        {
          country: "India",
          src: IndiaImg,
          description: "From the majestic Taj Mahal (fly outside NFZ) to the pink city forts of Jaipur and the vast Rann of Kutch, India offers vibrant and diverse aerial landscapes for drone pilots.",
          droneRules: [
            "Register your drone on the Digital Sky platform.",
            "Avoid flying near airports or over densely populated areas."
          ]
        },
        {
          country: "Japan",
          src: JapanImg,
          description: "Mount Fuji’s snow-capped peak, Kyoto’s temple rooftops, and Tokyo’s skyline blend tradition and modernity for stunning drone visuals.",
          droneRules: [
            "Avoid flying over crowds or in urban areas without permission.",
            "Flights over 150m require government approval."
          ]
        },
        {
          country: "China",
          src: ChinaImg,
          description: "Capture sweeping shots of the Great Wall, Zhangjiajie’s towering rock formations, and vibrant cityscapes like Shanghai’s skyline.",
          droneRules: [
            "Register your drone with the CAAC.",
            "Do not fly over government or military buildings."
          ]
        },
        {
          country: "Singapore",
          src: SingaporeImg,
          description: "Futuristic skylines at Marina Bay, Gardens by the Bay, and Sentosa beaches make Singapore a compact yet powerful drone location.",
          droneRules: [
            "CAAS approval is needed to fly in public spaces.",
            "Stay below 60 meters unless otherwise approved."
          ]
        },
        {
          country: "Thailand",
          src: ThailandImg,
          description: "From island paradises like Phi Phi to Bangkok’s vibrant cityscape and Chiang Mai temples, Thailand is a visual feast from the sky.",
          droneRules: [
            "Register with CAAT and carry valid insurance.",
            "Maintain visual line of sight during flight."
          ]
        }
      ]
    },
    {
      continent: "Europe",
      countries: [
        {
          country: "Italy",
          src: ItalyImg,
          description: "Soar over the Amalfi Coast, Venice’s canals, the Dolomites, and ancient ruins around Rome for a timeless European drone experience.",
          droneRules: [
            "Avoid flying over people or historical monuments.",
            "Registration and drone insurance are mandatory."
          ]
        },
        {
          country: "Denmark",
          src: DenmarkImg,
          description: "Drone over charming harbors like Nyhavn, stunning white cliffs like Møns Klint, and modern cities like Aarhus.",
          droneRules: [
            "Register drones over 250g.",
            "Maximum altitude allowed is 100 meters."
          ]
        },
        {
          country: "Iceland",
          src: IcelandImg,
          description: "Capture glaciers, volcanic fields, Skógafoss waterfall, and the black sand beaches with dramatic contrast and scale.",
          droneRules: [
            "Flying in national parks requires a permit.",
            "Maintain 150m distance from people and wildlife."
          ]
        },
        {
          country: "Ireland",
          src: IrelandImg,
          description: "Fly along the Cliffs of Moher, over castles like Rock of Cashel, or coastal views from Dublin Bay.",
          droneRules: [
            "Register drones over 1kg.",
            "Keep below 120m and avoid flying over people."
          ]
        },
        {
          country: "Norway",
          src: NorwayImg,
          description: "Breathtaking fjords, icy mountains, and unique landscapes like Trolltunga make Norway a top drone destination.",
          droneRules: [
            "Flying over crowds is strictly prohibited.",
            "Maintain at least 150m from people and infrastructure."
          ]
        },
        {
          country: "Switzerland",
          src: SwitzerlandImg,
          description: "Zermatt and the Matterhorn, alpine lakes, and quaint villages offer crystal-clear scenic drone backdrops.",
          droneRules: [
            "Keep drone flights below 120m altitude.",
            "Avoid nature reserves and tourist hotspots without permission."
          ]
        },
        {
          country: "Finland",
          src: FinlandImg,
          description: "Lapland’s snowy forests, Lake Saimaa, and the Northern Lights provide magical winter drone opportunities.",
          droneRules: [
            "Registration not needed for drones under 250g.",
            "Avoid flying in national parks or over crowds."
          ]
        },
        {
          country: "Luxembourg",
          src: LuxembourgImg,
          description: "Capture the beauty of Vianden Castle, lush forests, and the fairytale-like landscapes of the Grund district.",
          droneRules: [
            "Authorization required to fly above 50m or in urban zones.",
            "Respect privacy and do not fly over private property."
          ]
        },
        {
          country: "Netherlands",
          src: NetherlandsImg,
          description: "Kinderdijk’s windmills, Keukenhof’s tulip fields, and Amsterdam’s canals offer colorful, classic European views.",
          droneRules: [
            "Controlled airspace flights require permission.",
            "Stay below 120m and within visual range."
          ]
        },
        {
          country: "Sweden",
          src: SwedenImg,
          description: "Forested islands, historic towns, and aurora-lit skies across the Stockholm archipelago are drone heaven.",
          droneRules: [
            "Camera-equipped drones must be registered.",
            "Avoid flying near residential areas or during night."
          ]
        },
        {
          country: "UnitedKingdom",
          src: UnitedKingdomImg,
          description: "From the Lake District to London’s skyline, and countryside castles, the UK offers varied drone settings.",
          droneRules: [
            "Drones over 250g must be registered with the CAA.",
            "No flying over crowds, near airports, or above 120m."
          ]
        },
        {
          country: "Germany",
          src: GermanyImg,
          description: "Fly over Neuschwanstein Castle, the Black Forest, and Berlin’s modern skyline for diverse scenic footage.",
          droneRules: [
            "Registration and insurance are required.",
            "Maximum altitude is 100m; avoid residential zones."
          ]
        },
        {
          country: "France",
          src: FranceImg,
          description: "Get stunning shots of the Eiffel Tower (from outside NFZ), Mont Saint-Michel, and French Riviera coastlines.",
          droneRules: [
            "Register all drones regardless of weight.",
            "Special permission needed for city or monument flights."
          ]
        }
      ]
    }
  ];
  

export default shots;